'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = void 0;
var transport_1 = require("../../transport");
var Messages = /** @class */ (function () {
    function Messages() {
    }
    Messages.prototype.filter = function (params) {
        return transport_1.transport.request('messages/filter', params);
    };
    Messages.prototype.archive = function (params) {
        return transport_1.transport.request('messages/archive', params);
    };
    Messages.prototype.markAsRead = function (params) {
        return transport_1.transport.request('messages/read', params);
    };
    return Messages;
}());
exports.Messages = Messages;
